<template>
  <div>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formModeloContrato.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome</span>
          <vs-input
            class="w-full"
            name="Nome"
            id="Nome"
            v-model="formModeloContrato.tipoContrato"
            v-validate="{ required: true }"
            :state="validateState('Nome')"
            :class="validateStateClass('Nome')"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Tipo de Apólice</span>
          <v-select
            :options="listApolices"
            :reduce="(item) => item.id"
            name="Tipo de Apólice"
            id="Tipo de Apólice"
            v-model="formModeloContrato.idTipoApolice"
            v-validate="{ required: true }"
            :state="validateState('Tipo de Apólice')"
            :class="validateStateClass('Tipo de Apólice')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col flex justify-center w-full">
          <vs-button
            color="primary"
            type="filled"
            class="w-full mr-3 mb-2"
            @click.stop.prevent="popupActive = true"
            >Contrato</vs-button
          >
        </div>
      </div>

      <ErrorsAlert :errors="errors" />

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idModelo == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>

    <!------------ START INFORMAÇÕES DO Setor ------------>

    <Modal
      class="holamundo"
      :active.sync="popupActive"
      :title="`Editar Contrato`"
      @close="popupActive = false"
    >
      <div class="flex flex-col">
        <quill-editor
          v-model="formModeloContrato.modeloContrato"
        ></quill-editor>
        <vs-button
          color="primary"
          class="mb-2 my-5"
          @click="popupActive = false"
        >
          <span>Pronto</span>
        </vs-button>
      </div>
    </Modal>
    <!------------ END INFORMAÇÕES DO Setor ------------>
  </div>
</template>
<script>
import vSelect from 'vue-select';
import BotaoSubmit from '../../components/BotaoSubmit';
import ErrorsAlert from '../../components/ErrorsAlert';
import notify from '../../utils/notify';
import service from '../../services';

import functions from '../../utils/functions';
import utilsList from '../../utils/list';

// require styles
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import { quillEditor } from 'vue-quill-editor';
import Modal from '../../components/Modal.vue';

export default {
  components: {
    vSelect,
    BotaoSubmit,
    ErrorsAlert,
    quillEditor,
    Modal
  },
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  data() {
    return {
      controllerGeral: 'modelosContratos',
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      aguardeCadastro: false,
      formModeloContrato: {
        status: true,
        idModelo: null,
        tipoContrato: null,
        modeloContrato: null,
        idTipoApolice: null,
      },
      listApolices: [],
      popupActive: false,
    };
  },
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
  },
  methods: {
    preencheForm() {
      if (this.dados.idModelo) {
        this.formModeloContrato.idModelo = this.dados.idModelo;
        this.formModeloContrato.status =
          this.dados.deletedAt == null ? true : false;
        this.formModeloContrato.tipoContrato = this.dados.tipoContrato;
        this.formModeloContrato.modeloContrato = this.dados.modeloContrato;
        this.formModeloContrato.idTipoApolice = this.dados.idTipoApolice;
      } else {
        this.resetForm();
      }
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
    resetForm() {
      this.formModeloContrato = {
        status: true,
        idModelo: null,
        tipoContrato: null,
        idTipoApolice: null,
      };
    },
    async onSubmit() {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        return;
      }

      const action = this.formModeloContrato.idModelo
        ? 'Atualizar'
        : 'Adicionar';

      try {
        this.$vs.loading();
        await service.post(
          this.controllerGeral,
          action,
          this.formModeloContrato,
        );

        notify.notifySuccess(this.$vs, 'Dados atualizados com sucesso!');
        this.aguardeCadastro = false;
        this.$emit('concluido');
      } catch (error) {
        console.log(error);
      } finally {
        this.$vs.loading.close();
      }
    },
    getDominios() {
      functions.buscaDadosSelects(
        'tipoApolices',
        this.listApolices,
        'nome',
        'tipoApoliceId',
      );
    },
  },
  created() {
    this.getDominios();
  },
  mounted() {
    if (!this.$validator.fields.find({ name: 'Contrato' })) {
      this.$validator.attach({
        name: 'Contrato',
        rules: 'required',
        getter: () => this.formModeloContrato.modeloContrato,
      });
    }
  },
};
</script>
<style></style>
